import React, { useContext } from "react";
import "./ChanelFilters.scss";

import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import ScrollMenu from "react-horizontal-scrolling-menu";
import { ArrowLeftShort, ArrowRightShort } from "react-bootstrap-icons";
import { nFormatter } from "../../api/ReplayVariables";
import { UserContext } from "../../api/user/userContext";


// v2-1574: only filters here. The owner's actions (all private / all public, select) are in the channel header:
// placed at the end of this bar they looked like more tabs.
function ChanelFilters({ startUrl, filterValues }) {
  const { t } = useTranslation();

  // the slug itself may contain "-": the user id is the LAST "-<digits>" of the /c/<slug>-<id>/ segment
  const match = window.location.pathname.match(/\/opencards\/[^/]+\/c\/[^/]*-(\d+)\//);

  const userId = match ? parseInt(match[1], 10) : 0;
  const { user } = useContext(UserContext);
  const isCUrl = Number(user.id) === userId && userId !== 0;

  return (
    <div className={"chanel-filters-container d-flex flex-column"}>
      <div className="chanel-filters">
        <ScrollMenu
          hideSingleArrow={true}
          hideArrows={true}
          alignCenter={false}
          arrowClass="chanel-filters-arrow"
          arrowDisabledClass="disabled"
          arrowLeft={<ArrowLeftShort />}
          arrowRight={<ArrowRightShort />}
          data={[
            <NavLink
              key={"all"}
              to={startUrl}
              exact
              className={filterValues.replays === 0 ? "nb0" : ""}
            >
              <div>{t("chanelApp.filters.all")}</div>
              <div className="nb">{nFormatter(filterValues.replays)}</div>
            </NavLink>,
            <NavLink
              key={"vote1"}
              to={startUrl + "/vote1"}
              className={filterValues.replays1 === 0 ? "nb0" : ""}
            >
              <div>{t("replayApp.votes.1")}</div>
              <div className="nb">{nFormatter(filterValues.replays1)}</div>
            </NavLink>,
            <NavLink
              key={"vote2"}
              to={startUrl + "/vote2"}
              className={filterValues.replays2 === 0 ? "nb0" : ""}
            >
              <div>{t("replayApp.votes.2")}</div>
              <div className="nb">{nFormatter(filterValues.replays2)}</div>
            </NavLink>,
            <NavLink
              key={"vote3"}
              to={startUrl + "/vote3"}
              className={filterValues.replays3 === 0 ? "nb0" : ""}
            >
              <div>{t("replayApp.votes.3")}</div>
              <div className="nb">{nFormatter(filterValues.replays3)}</div>
            </NavLink>,
            <NavLink
              key={"vote4"}
              to={startUrl + "/vote4"}
              className={filterValues.replays4 === 0 ? "nb0" : ""}
            >
              <div>{t("replayApp.votes.4")}</div>
              <div className="nb">{nFormatter(filterValues.replays4)}</div>
            </NavLink>,
            <NavLink
              key={"viewed"}
              to={startUrl + "/viewed"}
              className={filterValues.viewed === 0 ? "nb0" : ""}
            >
              <span>{t("navigation.rankings.viewed")}</span>
              <span className="nb">{nFormatter(filterValues.viewed)}</span>
            </NavLink>,
            <NavLink
              key={"commented"}
              to={startUrl + "/commented"}
              className={filterValues.commented === 0 ? "nb0" : ""}
            >
              <span>{t("navigation.rankings.commented")}</span>
              <span className="nb">{nFormatter(filterValues.commented)}</span>
            </NavLink>,
            <NavLink
              key={"voted"}
              to={startUrl + "/voted"}
              className={filterValues.voted === 0 ? "nb0" : ""}
            >
              <span>{t("navigation.rankings.voted")}</span>
              <span className="nb">{nFormatter(filterValues.voted)}</span>
            </NavLink>,
            // the owner's own tabs: added only for him, so visitors get no empty items
            ...(isCUrl
              ? [
                  <NavLink
                    key={"public"}
                    to={startUrl + "/public"}
                    className={filterValues.public === 0 ? "nb0" : ""}
                  >
                    <span>{t("navigation.rankings.public")}</span>
                    <span className="nb">{nFormatter(filterValues.public)}</span>
                  </NavLink>,
                  <NavLink
                    key={"private"}
                    to={startUrl + "/private"}
                    className={filterValues.private === 0 ? "nb0" : ""}
                  >
                    <span>{t("navigation.rankings.private")}</span>
                    <span className="nb">{nFormatter(filterValues.private)}</span>
                  </NavLink>
                ]
              : [])
          ]}
        ></ScrollMenu>
      </div>
    </div>
  );
}
export default ChanelFilters;
